import DashboardCardContainer from "components/DashboardCardContainer/DashboardCardContainer";

interface PatientRecordsCardProps {
  data?: string[];
  onViewClick?: () => void;
}

const PatientRecordsCard = ({ data, onViewClick }: PatientRecordsCardProps) => {
  return (
    <DashboardCardContainer
      title="RKM Patient records not accessed"
      subtitle="(Past 30 days)"
      childrenClassName="flex justify-center items-center"
      children={
        data && (
          <div
            className={`${
              data.length === 0 ? "bg-tropicalRainForest" : "bg-crimson"
            } rounded-full w-52 h-52 flex items-center justify-center relative`}
          >
            <span className={`icon_svg icon_folder`} />

            <button
              className={`mt-3 absolute text-base leading-5 font-bold underline whitespace-pre-wrap text-center ${
                !data.length ? "pointer-events-none" : ""
              }`}
              onClick={onViewClick}
              disabled={!data.length}
            >
              {`${data.length ? "View\n" : ""}${data.length} ${
                data.length === 1 ? "patient" : "patients"
              }`}
            </button>
          </div>
        )
      }
    />
  );
};

export default PatientRecordsCard;
